import React from 'react';
import Footer from './Footer';
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"

const LayoutWithOutNavBar = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow mt-10">
        {children}
      </main>
      <Analytics />
      <SpeedInsights />
      <Footer />
    </div>
  );
};

export default LayoutWithOutNavBar;